import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { CATEGORIES, PRODUCTS } from '../mock/mock';
import ProductCard from '../components/ProductCard';

const Products = () => {
  const [active, setActive] = useState('all');
  const filtered = active === 'all' ? PRODUCTS : PRODUCTS.filter((p) => p.category === active);

  return (
    <div>
      {/* header */}
      <div className="ps-blue-bg text-white">
        <div className="max-w-7xl mx-auto px-6 py-14">
          <p className="font-oswald uppercase tracking-widest text-[#ffd400] text-sm mb-2">Shop</p>
          <h1 className="font-anton text-5xl">ALL PRODUCTS</h1>
          <p className="text-white/70 mt-3 max-w-xl">Browse our complete collection of premium toys, accessories and home essentials.</p>
        </div>
      </div>

      {/* category chips */}
      <div className="sticky top-[81px] z-30 bg-white/95 backdrop-blur border-b">
        <div className="max-w-7xl mx-auto px-6 py-4 flex gap-2 overflow-x-auto">
          <button onClick={() => setActive('all')} className={`whitespace-nowrap px-4 py-2 rounded-full font-oswald uppercase text-sm transition-colors ${active === 'all' ? 'ps-blue-bg text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>All</button>
          {CATEGORIES.map((c) => (
            <button key={c.slug} onClick={() => setActive(c.slug)} className={`whitespace-nowrap px-4 py-2 rounded-full font-oswald uppercase text-sm transition-colors ${active === c.slug ? 'ps-blue-bg text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'}`}>{c.name}</button>
          ))}
        </div>
      </div>

      {/* grid */}
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-5 sm:gap-6">
          {filtered.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      </div>
    </div>
  );
};

export default Products;
